import { render } from "./TranslationConfig.vue?vue&type=template&id=dcc60f18&scoped=true&ts=true"
import script from "./TranslationConfig.vue?vue&type=script&lang=ts"
export * from "./TranslationConfig.vue?vue&type=script&lang=ts"

import "./TranslationConfig.vue?vue&type=style&index=0&id=dcc60f18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc60f18"]])

export default __exports__